<template>
<div class="menuBody" >
    <RoomTree @RoomTree="RoomTree" />
        <RoomChargeDialog :param="diaLogData" @dialog="dialog" ref="RoomChargeDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px">
                房间收费标准列表  
                 <div style="float:right;margin-top:-5px;margin-right:10px;display:none"  >
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:cStandard:addbatch'"  @click="DownCourseAdd()">收费标准批量设置</el-button>
            </div>
                <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:cStandard:save'" @click="PropertyAdd()">收费标准设置</el-button>
            </div>
            </div>
  <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading"  @selection-change="handleSelectionChange"    
  style="overflow-y: scroll;" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" 
  :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column prop="itemName" label="收费项目"  ></el-table-column>
    <el-table-column prop="ext2" label="单价金额" ></el-table-column>
    <el-table-column prop="subjectsName" label="对应科目" ></el-table-column>
    <el-table-column prop="subjectsCode" label="对应科目代号" ></el-table-column>
    <el-table-column prop="ext1" label="计费方式" >
        <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.ext1=='0'" >按月收费</el-tag>
        <el-tag v-if="scope.row.ext1=='1'" >单价*面积</el-tag>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改" v-Jurisdiction="'expense:web:cs:cStandard:save'"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除" v-Jurisdiction="'expense:web:cs:cStandard:delete'" v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import RoomChargeDialog from "../common/RoomChargeDialog";
import RoomTree from "../common/RoomTree.vue";

export default {
  name: "RoomCharge",
  components: {RoomChargeDialog,RoomTree},
  data() {
    return {
      loading:false,
      osDatas:[],
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        CourseCode:"",
        CourseName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      roomId:"",
      customerId:"",
    }
  },
  methods: {
    dialog(data){
      if(data == false){
          this.getAllMenu()
      }
    },
    AmountChange(){
      var arr = this.amountval
      var ende = arr[arr.length-1]
      for(let val of this.amount){
        if(this.amountval == val.value){
          this.taxRateval = val.value
          this.taxRatelab = val.label
        }else{
          var end = arr[0]
          if(end == val.value){
            for(let arr of val.children){
              if(ende == arr.value){
                  this.taxRateval = arr.value
                  this.taxRatelab = arr.label
              }
            }
          }
        }
      }
    },
    handleSelectionChange(val){
      this.USERObj= val
    },
    RoomTree(data){
      this.loading = true
        if(data.roomId){
          this.customerId = data.customerId
            this.roomId = data.roomId
      this.AllData = data
       let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "roomId":data.roomId,
      }
        this.$http.post(this.$requestUrl.POST_ROOMCHARGE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
        }
    },
      handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "roomId":this.roomId,
      }
        this.$http.post(this.$requestUrl.POST_ROOMCHARGE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    PropertyAdd(){
        // 添加项目
    if(this.roomId.length>0){
      this.$refs.RoomChargeDialog.title = "添加";
      this.$refs.RoomChargeDialog.dialogVisible = true; 
      this.$refs.RoomChargeDialog.options = this.options
      this.$refs.RoomChargeDialog.roomId = this.roomId
      this.$refs.RoomChargeDialog.customerId = this.customerId
      this.$refs.RoomChargeDialog.ifelse = false
          let obj = {
            "feeitemName":"收费项目",
            "chargemode":"计费方式",
            "displayName":"对应科目",
            "subjectsName":"对应科目代号",
            "taxRate":"单价金额",
            "unit":"计算单位",
            "remark":"备注信息",
          }
          let row = {}
          row.obj = obj
         this.$refs.RoomChargeDialog.formLabelAlign= row;
        }else{
           this.$message({
          message: '请选择房间信息！',
          type: 'warning'
        });
        }
        
    },
    editMenu(row) { // 修改
      this.$refs.RoomChargeDialog.title = "修改";
      this.$refs.RoomChargeDialog.dialogVisible = true;
      this.$refs.RoomChargeDialog.options = this.options
      this.$refs.RoomChargeDialog.roomId = this.roomId
      this.$refs.RoomChargeDialog.customerId = this.customerId
      this.$refs.RoomChargeDialog.ChargeModeval = row.ext1
      this.$refs.RoomChargeDialog.unitval = row.ext3
      this.$refs.RoomChargeDialog.serviceRate = row.ext2
      this.$refs.RoomChargeDialog.value = row.itemCode
      this.$refs.RoomChargeDialog.ifelse = false
             let obj = {
            "feeitemName":"收费项目",
            "chargemode":"计费方式",
            "displayName":"对应科目",
            "subjectsName":"对应科目代号",
            "taxRate":"单价金额",
            "unit":"计算单位",
            "remark":"备注信息",
          }
        row.obj = obj
        this.$refs.RoomChargeDialog.formLabelAlign= row;
        },
        DownCourseAdd(){
          let array = []
          for(let val of this.USERObj){
            array.push(val.roomId)
          }
          if(this.USERObj.length>0){
                this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
                  if(res.data.code == 200){
                      var data = res.data.data;
                      // console.log(data)
                      // this.$refs.RoomChargeDialog.osDatas = data
                      this.$refs.RoomChargeDialog.ifelse = true
                      this.$refs.RoomChargeDialog.title = "收费标准批量设置";
                      this.$refs.RoomChargeDialog.dialogVisible = true;
                      this.$refs.RoomChargeDialog.roomIds = array
                      this.$refs.RoomChargeDialog.osDatas = data
                  }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }else{
            this.$message({
              message: '请最少选择一条收费标准!',
              type: 'warning'
            });
          }
        },
    delMenu(row){
  this.$confirm('是否确认要删除该标准?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
  this.$http.post(this.$requestUrl.DELETE_ROOMCHARGE+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.getAllMenu()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
     RevenueType(){
          this.$http.get(this.$requestUrl.GET_CHARGE_LIST).then((res)=>{
           let result = res.data;
        if (200 === result.code) {
          this.RevenueTypeone(result.data)
        }
        })
    },
    RevenueTypeone(params){
       var result = [];
                for (let val of params) {
 
                  if(val.parentCode == null || val.parentCode == ""){
                    var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }
                    parent.children = this.RevenueTypeTwo(val.subjectsCode,params)
                    result.push(parent);
                  }
                  if(val.parentCode == "0"){
                     var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "1"){

                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "600110"){  
                          var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "29290"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "10802"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      "type":val.parentCode
                    }

                    result.push(parent)
                  }
 
                  this.amount = result
    }
  },
      RevenueTypeTwo(id,array){
        let childs = new Array();
        for(let arr of array){
          if (arr.parentCode == id) {
           childs.push({
               'label': arr.subjectsName,
               'value': arr.subjectsCode,
               'type':arr.parentCode,
           });
          }
        }
         return childs;
    },
    ItemWeight(){
          this.$http.get(this.$requestUrl.GET_ITEM_TYPE).then((res)=>{
           let result = res.data;
           let arr = []
           for(let val of result.data){
                let obj = {
                   "value":val.feeCode,
                   "label":val.feeCode+","+val.feeName,
                   "type":val.id,
                   "subjectsCode":val.subjectsCode,
                   "subjectsName":val.subjectsName,
               }
               arr.push(obj)
           }
           this.options = arr
        })
    },
  },
  mounted() {
      this.ItemWeight();
  }
}
</script>

<style lang="scss">
// .el-table__body {
//     // 兼容safari
//     width: 100%;
//     //改变表格布局方式
//     table-layout: fixed !important
//   }

.menuBody {
  width: 100%;
  // border: 1px solid;
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>